import { FormikHelpers } from "formik";
import { TFunction } from "i18next";
import { BooksAddPayPalFundsFormValues } from "types/books";
import * as yup from "yup";
import { createAddFundsAmountValidation } from "./addFundsAmountValidation";

const addOverpayFundsFormik = (
  t: TFunction,
  booksCheckoutOverpay: any,
  currencySymbol: string,
  restoredValues?: Partial<BooksAddPayPalFundsFormValues> | null,
) => {
  return {
    initialValues: {
      amount: restoredValues?.amount ?? "",
    },

    validationSchema: yup.object({
      amount: createAddFundsAmountValidation(t, currencySymbol),
    }),
    onSubmit: (
      values: BooksAddPayPalFundsFormValues,
      { setSubmitting }: FormikHelpers<BooksAddPayPalFundsFormValues>,
    ) => {
      const { amount } = values;
      const amountValue = amount !== null ? +amount : 0;

      setSubmitting(true);
      booksCheckoutOverpay({
        amount: amountValue,
        onOpened: () => setSubmitting(false),
        onError: () => setSubmitting(false),
      });
    },
  };
};

export default addOverpayFundsFormik;
